export default __webpack_public_path__ + "maps-guides-markers-annotations-960-d114b3c03aec4f1c55a6a208e5a5cbb5.png";